module.exports = __webpack_public_path__ + "img/progress_044.127cf97c.png";